/**
 * PWA utilities — registro seguro del Service Worker.
 *
 * El registro se llama desde main.tsx tras el render. Skip en DEV para
 * evitar caches molestas durante desarrollo (HMR).
 */

export async function registerServiceWorker(): Promise<ServiceWorkerRegistration | null> {
  if (typeof window === 'undefined') return null
  if (!('serviceWorker' in navigator)) return null
  if (import.meta.env.DEV) return null

  try {
    const reg = await navigator.serviceWorker.register('/sw.js')
    return reg
  } catch (err) {
    console.error('[PWA] Service worker registration failed', err)
    return null
  }
}

/**
 * Detecta si la app esta corriendo en modo standalone (instalada).
 * iOS expone `navigator.standalone`; el resto usa display-mode.
 */
export function isStandalone(): boolean {
  if (typeof window === 'undefined') return false
  const mql = window.matchMedia?.('(display-mode: standalone)')
  if (mql?.matches) return true
  // iOS Safari legacy
  const navAny = window.navigator as Navigator & { standalone?: boolean }
  if (navAny.standalone) return true
  return false
}
